import CircularGallery from "components/CircularGallery";
import award1 from "assets/awards/award_1.png";
import award2 from "assets/awards/award_2.png";
import award3 from "assets/awards/award_3.png";
import award4 from "assets/awards/award_4.png";

const AWARD_ITEMS = [
  { image: award1, text: "Philippine Aviculture Federation" },
  { image: award2, text: "1st, 2nd & 3rd Place — Lovebirds" },
  { image: award3, text: "1st International Bird Show" },
  { image: award4, text: "7th Open Int'l Bird Show — 2019" },
];

const AwardsGallery = () => (
  <section id="awards-section" className="bg-[#0a0908] py-20 md:py-28">
    <div className="container mb-10 text-center">
      <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-amber">
        Recognized &amp; Celebrated
      </p>
      <h2 className="font-didot text-3xl leading-tight text-white sm:text-4xl md:text-[2.75rem]">
        Awards Won Throughout the Years
      </h2>
    </div>

    <div style={{ height: "600px", position: "relative" }}>
      <CircularGallery
        items={AWARD_ITEMS}
        bend={3}
        textColor="#ffffff"
        borderRadius={0.05}
        scrollSpeed={1.3}
        scrollEase={0.014}
      />
    </div>
  </section>
);

export default AwardsGallery;
